import { render, staticRenderFns } from "./RelationshipsView.vue?vue&type=template&id=2acfa5d5&scoped=true&"
import script from "./RelationshipsView.vue?vue&type=script&lang=js&"
export * from "./RelationshipsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2acfa5d5",
  null
  
)

export default component.exports